import React, { useCallback, useContext } from 'react';
import { EditorLabel } from './EditorLabel';
import { IEditorProps } from './Editor';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';

export interface ITableTemplateEditorProps extends IEditorProps {}
export function TableTemplateEditor({ child, path, id }: ITableTemplateEditorProps) {
  const context = useContext(PropertyEditorContext);

  const showLayoutDialog = useCallback(() => {
    context.onShowDialogue({
      node: child,
      editingContextId: context.editingContextId,
      path,
    });
  }, [child, path, context]);

  return (
    <EditorLabel editor={child} path={path} htmlFor={id}>
      <div id={id} className="dp-three-dots-btn-blue" onClick={showLayoutDialog}></div>
    </EditorLabel>
  );
}
